// extracted by mini-css-extract-plugin
module.exports = {"link-to-details":"c6e8ba5398--link-to-details--2Rtpm"};